module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "docs"
  }, [_c('p', {
    staticClass: "doc_text",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_vm._v("1.理赔申请表，包括事件发生的经过的描述等")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("2.用户有效身份证正反面彩色复印件")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("3.用户向公关机关报案的相关证明（报案或立案证明）")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("4.非本人授权交易补偿申请表")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("5.用户被盗账户的信息截屏")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("6.被盗账户对账单截屏（已标记盗刷交易明细信息：交易日期，交易商户，交易币种，交易金额，入帐币种，入账金额）")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("7.被盗账户挂失证明（信息截屏，包含挂失日期）")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("8.出险期间用户手机或其他终端设备在公关机关的备案数据")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("9.其他本公司或保险公司认为对向用户提供理赔服务所必须的材料")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a90f103"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs.vue
// module id = 821
// module chunks = 1